import React, { useState, useEffect } from "react";
import {
  Container,
  CircularProgress,
  Grid,
  IconButton,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  Stack,
} from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ResponsiveNav from "../ptwopproduct/navbar";
import BankDetailsModal from "../PtwoPMarket/bankdetails"; 
import DeleteIcon from "@mui/icons-material/Delete";
const FavoriteProducts = () => {
  const [favorites, setFavorites] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [showBankModal, setShowBankModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFavoriteProducts = async () => {
      setLoading(true);
      const token = localStorage.getItem("token");
      const storedEmail = sessionStorage.getItem("userEmail");

      if (!token || !storedEmail) {
        console.error("Token or User email is missing. Please log in.");
        setLoading(false);
        return;
      }

      const encodedEmail = encodeURIComponent(storedEmail);
      const apiUrl = `https://daradservice.azurewebsites.net/api/P2PProducts/get-favorites?customerEmail=${encodedEmail}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        if (data.status) {
          setFavorites(data.data);
        } else {
          console.warn("No favorite products found in response:", data);
          setFavorites([]);
        }
      } catch (error) {
        console.error("Error fetching favorite products:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFavoriteProducts();
  }, []);

  const handleMakeOrder = async (productId) => {
    const token = localStorage.getItem("token");
    const userId = sessionStorage.getItem("userId");

    if (!userId) {
      alert("Please log in to proceed with the order.");
      return;
    }

    if (!productId) {
      alert("Invalid product selection.");
      return;
    }

    if (!token) {
      alert("You need to log in first.");
      return;
    }

    try {
      const response = await fetch(
        `https://daradservice.azurewebsites.net/api/P2PProducts/save-order?ProductId=${productId}&UserId=${userId}`,
        {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok && data.status) {
        setSelectedProductId(productId);
        setShowBankModal(true); // Open modal
      } else {
        alert(data.message || "Order could not be placed.");
      }
    } catch (error) {
      alert("An error occurred while making the order. Please try again.");
    }
  };

  const handleDeleteProduct = (productId) => {
    if (!productId) {
      alert("Invalid product selection.");
      return;
    }
    navigate(`/product/delete/${productId}`);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const filteredFavorites = favorites.filter(
    (product) =>
      (product.title && product.title.toLowerCase().includes(searchTerm)) ||
      (product.description && product.description.toLowerCase().includes(searchTerm))
  );

  return (
    <Container maxWidth={isDesktop ? "lg" : "sm"} sx={{ py: 4, px: 2 }}>
      <ResponsiveNav
        searchValue={searchTerm}
        onSearchChange={handleSearchChange}
        searchPlaceholder="Search favorites..."
        breadcrumbItems={[{ label: "Home", link: "/" }, { label: "Favorites", link: "/favorites" }]}
      />

    <Box
                sx={{
                 borderBottom: "1px solid #ccc",
                mt: isDesktop ? "20px" : "20px",
                mb:"40px"
               }}>  
        <Typography variant="h4" fontWeight={700} color="#5604F6"   sx={{ color: "#2400FF", mb: 1, fontSize: isDesktop ? "48px" : "36px", }}
        
        >
          Favorite Products
        </Typography>
        <Typography sx={{ fontSize: "18px", m: "10px" }}>
          Browse and manage your favorite products.
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", mt:"10px", justifyContent: "center", alignItems: "center", height: "50vh" }}>
          <CircularProgress />
        </Box>
      ) : filteredFavorites.length > 0 ? (
        <Grid container spacing={isDesktop ? 6 : 3} rowSpacing={isDesktop ? 4 : 2}>
          {filteredFavorites.map((product) => (
            <Grid item xs={12} sm={6} md={6} lg={4} key={product.productId}>
              <Card sx={{ p: 2, boxShadow: 3 }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={product.imagePath || "/placeholder.jpg"}
                  alt={product.title || "Product Image"}
                  sx={{ borderRadius: "8px" }}
                />
                <CardContent>
                  <Typography variant="h6">{product.title}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {product.description}
                  </Typography>
                  <Stack
  direction="row"
  spacing={1} // Reduce spacing for a compact layout
  sx={{
    mt: 2,
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  <Button
    variant="contained"
    onClick={() => handleMakeOrder(product.productId)}
    sx={{
      flex: 1, // Makes button take available space
      maxWidth: "140px", // Limits width for better UI
      backgroundColor: "#5604F6",
      color: "white",
      fontWeight: "bold",
      px: "10px",
      py: "6px",
      borderRadius: "999px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#4503C6",
      },
    }}
  >
    Make Order
  </Button>

  <IconButton
    color="error"
    onClick={() => handleDeleteProduct(product.productId)}
    sx={{
      borderRadius: "50%",
      backgroundColor: "#FDEAEA",
      "&:hover": {
        backgroundColor: "#FBC7C7",
      },
    }}
  >
    <DeleteIcon />
  </IconButton>
</Stack>

                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography sx={{ mt: 4, textAlign: "center", fontSize: "18px" }}>No favorite products found.</Typography>
      )}

      {/* Modal for Bank Details */}
      <BankDetailsModal open={showBankModal} onClose={() => setShowBankModal(false)} productId={selectedProductId} />
    </Container>
  );
};

export default FavoriteProducts;
